import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export function handleAnnouncementBar() {
	const bar = document.querySelector<HTMLElement>('#announcement-bar');

	bar && new Swiper(bar, {
		slidesPerView: 1,
		modules: [Autoplay],
		speed: 800,
		autoplay: {
			delay: 2000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false
		}
	})
}